import { render, staticRenderFns } from "./SwitchField.vue?vue&type=template&id=e0ee08f6&"
import script from "./SwitchField.vue?vue&type=script&lang=js&"
export * from "./SwitchField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/allianzebpo/public_html/payment/crater/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0ee08f6')) {
      api.createRecord('e0ee08f6', component.options)
    } else {
      api.reload('e0ee08f6', component.options)
    }
    module.hot.accept("./SwitchField.vue?vue&type=template&id=e0ee08f6&", function () {
      api.rerender('e0ee08f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/custom-fields/SwitchField.vue"
export default component.exports